import React,{useState,useCallback} from 'react';
import {useDropzone} from 'react-dropzone';

/*open source npm module
documentation @ https://www.npmjs.com/package/react-dropzone */

function Basic(props) {
  const [file,setFile] = useState(null);
  
  // const files = acceptedFiles.map(file => (
  //   <li key={file.path}>
  //     {file.path} - {file.size} bytes
  //   </li>
    
  // ));
  const onDrop = useCallback(acceptedFiles => {
    acceptedFiles.map((files) =>{
      setFile(files.path+" - "+files.size+"bytes");
      props.upload(files.path);
    })
  }, [])

  const {getRootProps, getInputProps} = useDropzone({onDrop});
  return (
    <section className="container">
      <div {...getRootProps({className: 'dropzone'})}>
        <input {...getInputProps()}/>
        <p style={{paddingTop:"1rem"}}>Drag {'&'} Drop your Prescription Here <span><img className= 'field-icon' src= '/header/display-3-aux/cloudshare_icon.svg' alt= 'cloudshare icon'/></span></p>
       {file}
      </div>
      
      {/* {files ? <aside><ul>{files}</ul></aside> : null}
      {console.log(files)} */}
    </section>
  );
}

export default Basic;